// extracted by mini-css-extract-plugin
module.exports = {"addModal":"Committees_addModal__3oHZo","subHeader":"Committees_subHeader__3ewyH","addButton":"Committees_addButton__2Re2Q","loading":"Committees_loading__2Jrnh"};